import { FC } from "react";
import { Container } from "./styles";

import emptyAttachmentsImg from "Static/images/empty-attachments.png";

interface IEmptyAttachmentsProps {
  padding?: number;
}

const EmptyAttachments: FC<IEmptyAttachmentsProps> = ({ padding }) => {
  return (
    <Container $padding={padding}>
      <img
        src={emptyAttachmentsImg}
        alt="Nenhum anexo vinculado"
      />
      <span className="title">Nenhum anexo vinculado</span>
      <span className="description">
        Ainda não foi carregado nenhum arquivo na atividade.
      </span>
    </Container>
  )
}

export default EmptyAttachments;
